module.exports = __webpack_public_path__ + "img/1582477330.fb64aef8.jpg";